import { NoteMarkType } from '~/services/api/enums';

export const noteMarkTypeOptions = [
  { value: NoteMarkType.None, label: 'None' },
  { value: NoteMarkType.Emr, label: 'EMR' },
  { value: NoteMarkType.Triage, label: 'Triage' },
];

export default {};
